import { injectable } from "inversify";
import { ScriptService } from ".";
import { ServiceBase } from "./ServiceBase";

/**
 * Script service, enables registering scripts and executing them at a later time in the order registered.
 */
@injectable()
export class IpfScriptService extends ServiceBase implements ScriptService {

    private scripts: Array<Function> = [];
    private executedScripts: Array<Function> = [];

	/**
	 * @inheritdoc
	 */
    public register(func: Function): void {

        this.scripts.push(func);
    }

	/**
	 * @inheritdoc
	 */
    public run(): void {

        const copy: Array<Function> = [];

        this.scripts.forEach(script => {

            copy.push(script);
        });

        copy.forEach((script, index) => {

            script();

            this.scripts.splice(0, 1);

            this.executedScripts.push(script);
        });
    }
}